<template>
  <img :src="src" :style="{width: `${width}px`, height: `${height}px` }" :class="{'gray-outline': withBorder}">
</template>

<script>
export default {

   props:{

       width:{
           type: String,
           default: "40"
       },

       height:{
           type: String,
           default: "40"
       },

       src:{
           type: String,
           default: ""
       },

        withBorder:{
           type: Boolean,
           default: false
       }
   }

}
</script>

<style scoped>
   img{
      border-radius: 50%;
   }
   
   .gray-outline{
      padding: 2px;
      border: 0.9px solid #DFE0EB;
   }
</style>